export const styles = () => ({
  breadcrumb: {
    margin: 20,
  },
});
